import { OcmConnection, OcmPoi } from '../../../stores/types/ocm.interface';

export enum ChargerLevel {
  LEVEL_1 = 1,
  LEVEL_2 = 2,
  LEVEL_3 = 3,
}

export enum FinderStatus {
  AVAILABLE = 'available',
  IN_USE = 'in_use',
  OPERATIONAL = 'operational',
  PARTLY_OPERATIONAL = 'partly_operational',
  TEMPORARILY_UNAVAILABLE = 'temporarily_unavailable',
  OFFLINE = 'offline',
  UNKNOWN = 'unknown',
}

export interface FinderOrigin {
  latitude: number;
  longitude: number;
  label: string;
}

export interface FinderFilters {
  connectorTypes: string[];
  level?: ChargerLevel;
  includeUnknownStatus: boolean;
  /** Empty means any network */
  networkIds: number[];
}

export interface FinderResult {
  poi: OcmPoi;
  latitude: number;
  longitude: number;
  distanceKm: number;
  status: FinderStatus;
  /** Only the connectors that match the filters */
  connections: OcmConnection[];
  maxPowerKw: number;
  networkId: number;
}

export interface NetworkOption {
  id: number;
  /** null for sites whose operator is not listed */
  name: string | null;
  siteCount: number;
}
